import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { authApi } from '../api/auth';

export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') ?? '';
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    if (password !== confirmPassword) { setError('Passwords do not match'); return; }
    if (!token) { setError('Missing or invalid reset link'); return; }
    setLoading(true);
    try {
      await authApi.resetPassword(token, password);
      navigate('/login', { replace: true, state: { flash: 'Password reset. Please log in with your new password.' } });
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Reset failed — the link may have expired');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg,#1e3a5f 0%,#2563eb 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1rem' }}>
      <div style={{ background: 'white', borderRadius: 20, padding: '2.5rem', width: '100%', maxWidth: 400, boxShadow: '0 20px 60px rgba(0,0,0,0.25)' }}>
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <div style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>🔒</div>
          <h1 style={{ fontSize: '1.5rem', fontWeight: 800, color: '#1e3a5f' }}>Reset password</h1>
          <p style={{ color: '#64748b', fontSize: '0.85rem', marginTop: '0.25rem' }}>Choose a new password for your account.</p>
        </div>

        {error && <div className="error-box">{error}</div>}

        {!token ? (
          <p style={{ textAlign: 'center', color: '#374151', fontSize: '0.9rem' }}>
            This link is missing its token. Please use the link from your email, or{' '}
            <Link to="/forgot-password" style={{ color: '#2563eb', fontWeight: 600 }}>request a new one</Link>.
          </p>
        ) : (
          <form onSubmit={handleSubmit}>
            <label style={{ display: 'grid', gap: '0.3rem', marginBottom: '1rem', fontSize: '0.82rem', fontWeight: 500, color: '#374151' }}>
              New password
              <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="At least 8 characters" required minLength={8} autoFocus />
            </label>
            <label style={{ display: 'grid', gap: '0.3rem', marginBottom: '1.5rem', fontSize: '0.82rem', fontWeight: 500, color: '#374151' }}>
              Confirm new password
              <input type="password" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} placeholder="Re-enter password" required minLength={8} />
            </label>
            <button type="submit" className="btn btn-primary" style={{ width: '100%', justifyContent: 'center', padding: '0.75rem' }} disabled={loading}>
              {loading ? <span className="spinner" style={{ width: 16, height: 16 }} /> : 'Reset password →'}
            </button>
          </form>
        )}

        <p style={{ textAlign: 'center', marginTop: '1.5rem', fontSize: '0.85rem', color: '#64748b' }}>
          <Link to="/login" style={{ color: '#2563eb', fontWeight: 600 }}>← Back to sign in</Link>
        </p>
      </div>
    </div>
  );
}
